import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class ScrollX extends React.Component {

    constructor() {
        super();
        this.state = {
            scrollPoz: 0,
            disableLeft: false,
            disableRight: false,
            disableRounds: false,
            startX: 0,
            shouldScroll: false,
        };
    }
    componentDidMount() {
        this.refs.scroll.addEventListener('scroll', this.scrollListener.bind(this), false);
    }

    componentWillUnmount() {
        this.refs.scroll.removeEventListener('scroll', this.scrollListener.bind(this), false);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.activeLot && this.props.activeLot) {
            if (prevProps.activeLot.name_lot !== this.props.activeLot.name_lot) {
                this.setState({ scrollPoz: 0 })
            }
        }
        this.refs.scroll.scrollLeft = this.state.scrollPoz
        var max = this.refs.scroll.scrollWidth - this.refs.scroll.offsetWidth

        if ((this.refs.scroll.scrollLeft === 0) && (this.state.disableLeft === false)) {
            this.setState({ disableLeft: true })
        }
        else if ((this.refs.scroll.scrollLeft > 0) && (this.state.disableLeft === true)) {
            this.setState({ disableLeft: false })
        }

        if ((this.refs.scroll.scrollLeft === max) && (this.state.disableRight === false)) {
            this.setState({ disableRight: true })
        }
        else if ((this.refs.scroll.scrollLeft < max) && (this.state.disableRight === true)) {
            this.setState({ disableRight: false })
        }
        if (this.props.runde && prevProps.runde) {
            if (this.props.runde.length !== prevProps.runde.length) {
                if (this.props.info === 'runde') {
                    if (this.props.runde.length <= 10) {
                        this.setState({
                            disableRounds: true
                        })
                    } else {
                        this.setState({
                            disableRounds: false
                        })
                    }
                }
            }
        }
    }

    scrollListener() {
        this.setState({ scrollPoz: this.refs.scroll.scrollLeft })
    }

    changePoz(val) {
        var stop = this.refs.scroll.scrollLeft + (this.props.amount * val)
        this.scrollAnimate(val, stop)
    }
    scrollAnimate(val, stop) {
        var speed = Math.round(this.props.amount / this.props.speed)
        setTimeout(() => {
            if ((val === 1) && (this.state.scrollPoz < stop)) {
                var max = this.refs.scroll.scrollWidth - this.refs.scroll.offsetWidth
                if (this.refs.scroll.scrollLeft < max) {
                    this.setState({ scrollPoz: this.state.scrollPoz + speed })
                    this.scrollAnimate(val, stop)
                } else {
                    this.setState({ scrollPoz: max })
                }
            }
            if ((val === -1) && (this.state.scrollPoz > stop)) {
                if (this.refs.scroll.scrollLeft > 0) {
                    this.setState({ scrollPoz: this.state.scrollPoz - speed })
                    this.scrollAnimate(val, stop)
                } else {
                    this.setState({ scrollPoz: 0 })
                }
            }
        }, 10);
    }
    disableBtns(val) {
        if (this.state.disableRounds === true) {

            return true
        } else {
            if (val === 'left') {
                return this.state.disableLeft
            } else if (val === 'right') {
                return this.state.disableRight
            }
        }
    }
    startScrollH(e) {
        let currMousePos = e.pageX - this.refs.scroll.offsetLeft;
        this.setState({ shouldScroll: true, startX: currMousePos })
    }

    scrollH(e) {
        if (this.state.shouldScroll) {
            let currMousePos = e.pageX - this.refs.scroll.offsetLeft;
            const oldScrollPos = this.state.scrollPoz;
            const x = e.pageX - this.refs.scroll.offsetLeft;
            const walk = (x - this.state.startX);
            const amount = this.state.scrollPoz - walk;
            var max = this.refs.scroll.scrollWidth - this.refs.scroll.offsetWidth;
            if (amount < max && ((oldScrollPos - walk) > 0)) {
                this.setState({ scrollPoz: oldScrollPos - walk, startX: currMousePos })

            }
        }
    }
    endScrollH(e) {
        this.setState({ shouldScroll: false })
    }
    render() {
        var style = {
            width: this.props.width,
            overflow: 'auto',
            display: 'inline-block',
            float: 'left',
        }
        return (
            <div className="scroll-container">
                <div className="con-but-scroll oriz">
                    <button className="oriz left" onClick={this.changePoz.bind(this, -1)} disabled={this.disableBtns('left')}>
                        <img src="img/icon/left-scroll.png" alt="" />
                    </button>
                </div>
                <div style={style} ref="scroll" className="con-scrol"
                    onMouseDown={this.startScrollH.bind(this)}
                    onMouseMove={this.scrollH.bind(this)}
                    onMouseUp={this.endScrollH.bind(this)}
                    onMouseLeave={this.endScrollH.bind(this)}
                >
                    <div
                        className="scroll-terminal"
                        style={{ width: 'max-content' }}
                    >
                        {this.props.scrollData}
                    </div>
                </div>
                <div className="con-but-scroll oriz">
                    <button className="oriz right" onClick={this.changePoz.bind(this, 1)} disabled={this.disableBtns('right')}>
                        <img src="img/icon/right-scroll.png" alt="" />
                    </button>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        runde: state.runde,
        activeLot: state.activeLot
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(ScrollX);